// extracted by mini-css-extract-plugin
export default {"container":"Reranker_container__13Wwn","footer":"Reranker_footer__20R8C"};